export default __webpack_public_path__ + "static/media/Business-Management-1.99ef73ff.jpeg";